import API from "../API";
import { AxiosResponse } from "axios";

export const checkUser = async (email: string): Promise<AxiosResponse> =>
  API.post(`/group/user/check`, { email });

type UserCreatePayload = {
  name: string;
  email: string;
  subtype: string;
  agencyCode: string;
  groupId: string;
  entityId: string;
};

export const createUser = async (
  payload: UserCreatePayload
): Promise<AxiosResponse> => API.post("/group/user/create", payload);
